import config from "config/config";

export const THEME_COLOR = "#F9FAFC";
export const FB_APP_ID = "829396587256028";
export const DNS_PREFETCH_LINKS = ["//ajax.googleapis.com", "//www.airhelp.com", "//img.airhelp.com"];
export const PRECONNECT_LINKS = ["https://img.airhelp.com/"];
export const DEFAULT_FEATURED_IMAGE = `${config.staticUrl}/i/images/social-share-image.png`;
export const OG_IMAGE_DIMENSIONS = {
  height: "627",
  width: "1200",
};
export const VERIFICATION_SERVICES = [
  {
    name: "yandex-verification",
    content: "872f8d8742eb78fd",
  },
  {
    name: "msvalidate.01",
    content: "E4C0D88D9D2FD7202F77790E0D62B7D3",
  },
];
